import React from 'react';
import PropTypes from 'prop-types';

const CrossIcon = props => (
  <svg width={24} height={24} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m8 8.707-4.596 4.596a.5.5 0 0 1-.707-.707L7.293 8 2.697 3.404a.5.5 0 0 1 .707-.707L8 7.293l4.596-4.596a.5.5 0 0 1 .707.707L8.707 8l4.596 4.596a.5.5 0 0 1-.707.707z" fill="currentColor" />
  </svg>
);

CrossIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
};

CrossIcon.defaultProps = {
  className: undefined,
  onClick: undefined,
  onKeyDown: undefined,
};

export default CrossIcon;
